import { takeEvery, fork, put, all, call, delay } from 'redux-saga/effects';

import { downloadInvoiceCsvUrl, invoiceUrl } from '../../shared/helpers/endPoints';
import {
    CREATE_SIMPLE_INVOICE,
    DELETE_INVOICE,
    DOWNLOAD_INVOICE_CSV,
    GET_ALL_INVOICES,
    GET_SINGLE_INVOICE
} from './actionTypes';
import { fetchJSON } from '../../shared/helpers/apiCalls';
import {
    downloadInvoiceCsvFailure,
    downloadInvoiceCsvSuccess,
    getAllInvoices,
    setAllInvoices,
    setCreatedSimpleInvoice
} from './action';
import { setModal, setProcessLoading } from '../action';
import { getStoreLocal } from '../../shared/helpers/utils';
import { authService } from '../../modules/users/services/dependency.injection';

function* callGetAllInvoices({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: invoiceUrl(modeType, ''),
            params: { ...values },
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setAllInvoices(response.data));
    } catch (error) {}
}
function* callCreateSimpleInvoice({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: invoiceUrl(modeType, '/simple-invoice'),
            data: values,
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);
        yield put(getAllInvoices({ merchantId: values.merchantId, limit: 10, offset: 0 }));

        yield put(setCreatedSimpleInvoice(response.data));
        yield delay(500);
        yield put(setProcessLoading(false));
        yield put(setModal({ simpleInvoiceModal: false, sendInvoiceRequestModal: true }));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
    }
}

function* callDeleteInvoice({ payload: invoiceId }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'DELETE',
            url: invoiceUrl(modeType, `/${invoiceId}`),

            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };
        // const merchantId = getStoreLocal('merchantId');
        const merchantId = authService.getToken('merchant-id');

        yield call(fetchJSON, options);
        yield put(getAllInvoices({ merchantId, limit: 10, offset: 0 }));

        yield put(setProcessLoading(false));
        yield put(setModal({ deleteInvoiceModal: false }));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
    }
}

function* getInvoiceById({ payload: invoiceId }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: invoiceUrl(modeType, `/${invoiceId}`),

            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);
        yield put(setCreatedSimpleInvoice(response.data));
    } catch (err) {}
}

function* downloadCsvForInvoice({ payload: values }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: downloadInvoiceCsvUrl(modeType, values),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        const response = yield call(fetchJSON, options);

        const blob = new Blob([response.data], { type: 'text/csv' });
        const blobUrl = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobUrl;
        tempLink.download = 'invoice.csv';
        tempLink.setAttribute('target', '_blank');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobUrl);

        yield put(downloadInvoiceCsvSuccess('You have successfully downloaded the csv'));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(downloadInvoiceCsvFailure(message));
    }
}

export function* watchCallDeleteInvoice() {
    yield takeEvery(DELETE_INVOICE, callDeleteInvoice);
}

export function* watchCallCreateSimpleInvoice() {
    yield takeEvery(CREATE_SIMPLE_INVOICE, callCreateSimpleInvoice);
}

export function* watchCallGetAllInvoices() {
    yield takeEvery(GET_ALL_INVOICES, callGetAllInvoices);
}

export function* watchCallGetSingleInvoice() {
    yield takeEvery(GET_SINGLE_INVOICE, getInvoiceById);
}

export function* watchCallDownloadCsvForInvoice() {
    yield takeEvery(DOWNLOAD_INVOICE_CSV, downloadCsvForInvoice);
}

function* invoicesSaga() {
    yield all([
        fork(watchCallGetAllInvoices),
        fork(watchCallCreateSimpleInvoice),
        fork(watchCallDeleteInvoice),
        fork(watchCallGetSingleInvoice),
        fork(watchCallDownloadCsvForInvoice)
    ]);
}
export default invoicesSaga;
